module.exports = __webpack_public_path__ + "img/fluent-hero-illustration.b0eec42a.png";